import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import boardEngine from '../../../../../Widgets/DataPainterWidget/BoardWidget/BoardEngine';
import { BOARD_TARGET_PICK } from '../../../../../Widgets/DataPainterWidget/BoardWidget/boardConst';
import commandEngine from './CommandEngine';
import { CMD_BOARD_REGISTRY_KEY, META_TYPE, META_VER } from './boardCommandRegisteryType';

/**
 * Registers the /board command — multi-instance, target = board rk.
 * /board → board picker, /board PNL3_FE → that board (case-insensitive title match).
 */
export function registerBoardCommand() {
    commandEngine.register('/board', {
        hint: '[board] — board overview, e.g. /board or /board PNL3_FE',
        get params() {
            return [
                {
                    name: 'board',
                    options: boardEngine.getBoards().map((b) => ({ label: b.title, value: b.title })),
                },
            ];
        },
        handler: (params) => {
            const [name] = params ?? [];
            const board = name?.trim() ? boardEngine.findBoard(name.trim()) : null;
            cardPainterManager.openCard(CMD_BOARD_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target: board?.rk ?? BOARD_TARGET_PICK });
        },
    });
}
